// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:39.397Z
// Property: Trace Apts. (ID: 6767906449165637)
// Collections: 22 amenities, 9 floorplans (live), 25 photos, 64 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165637",
  "property_external_id": "nxlmzdp",
  "property_zillow_url": "https://www.zillow.com/b/340-arbor-dr-ridgeland-ms-5Yy8Fv/",
  "property_apartments_url": "https://www.apartments.com/trace-apts-ridgeland-ms/nxlmzdp/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Trace+of+Ridgeland/data=!4m2!3m1!1s0x0:0x44b1a59480353b42?sa=X&ved=2ahUKEwiwzMzegb2SAxW-hIkEHYDrExcQ_BJ6BAhCEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "16038094159",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "trace-apts.",
  "property_name": "Trace Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/trace-of-ridgeland/",
  "property_domain": null,
  "property_address": "340 Arbor Drive",
  "property_full_address": "340 Arbor Drive, Ridgeland, MS, 39157",
  "property_address_1": "340 Arbor Drive",
  "property_address_2": null,
  "property_address_city": "Ridgeland",
  "property_address_state": "MS",
  "property_address_zip_full": null,
  "property_address_zip": "39157",
  "property_address_country": "US",
  "property_address_county": "Madison County",
  "property_neighborhood_address": "https://www.caseusa.com/apartments/ms/ridgeland/the-trace-of-ridgeland?cpm=apartments",
  "property_address_latitude": "32.4095",
  "property_address_longitude": "-90.1275",
  "property_email": "thetrace@caseusa.com",
  "property_phone": "(601) 751-4575",
  "property_call_tracking_phone": "855-933-2417",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Trace Apts. in Ridgeland, Mississippi, vibrant living awaits. Choose from spacious one or two-bedroom floor plans and indulge in a range of amenities, from refreshing pools and a fully-equipped fitness center to tennis courts and serene picnic areas. Your perfect home is just a tour away—see what’s available today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Trace Apartments, your ideal home nestled in the heart of Ridgeland, Mississippi. Our community offers spacious floor plans, featuring both one and two-bedroom options designed to suit your lifestyle. Whether you’re a young professional, a growing family, or someone looking for a tranquil living environment, we have the perfect space for you. \n\nAt Trace Apartments, we believe in providing our residents with top-notch amenities. Dive into our sparkling pool on warm summer days, or stay active at our fully equipped fitness center, racquetball court, and tennis courts. Enjoy friendly matches at our volleyball courts, or unwind on the sundeck with friends in our picnic area. For your convenience, we offer on-site laundry facilities, a car wash area, and dedicated maintenance and property management staff to ensure your living experience is seamless.\n\nEach apartment comes with modern features such as air conditioning, high-speed internet access, cable readiness, and cozy ceiling fans. Select units also include washer and dryer hookups, refrigerators with ice makers, and private patios, giving you the comfort of home. \n\nLocated in a vibrant neighborhood with easy access to shopping, dining, and entertainment, Trace Apartments supports an active lifestyle while offering a peaceful retreat to unwind in. \n\nDon’t miss out on the opportunity to call Trace Apartments your new home! Browse our availability or schedule a tour today to explore everything our community has to offer. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-c3ee-74d9-add6-0d0cb970c51f.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with parked cars in the foreground.",
    "public_id": "019cfb4b-c3ee-74d9-add6-0d0cb970c51f",
    "storage_key": "property/6767906449165637/019cfb4b-c3ee-74d9-add6-0d0cb970c51f.webp",
    "width": 2048,
    "height": 1534
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Contact Leasing Office for details",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://traceapartmentsridgeland.securecafe.com/onlineleasing/trace-apts/floorplans.aspx",
  "property_resident_portal_url": "https://traceapartmentsridgeland.securecafe.com/residentservices/trace-apts/userlogin.aspx",
  "property_apply_now_url": "https://traceapartmentsridgeland.securecafe.com/onlineleasing/trace-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-e4bb-754b-bd15-f4074836b303.webp",
  "property_primary_logo_media": {
    "alt_text": "The Trace of Ridgeland logo",
    "public_id": "019cfb4a-e4bb-754b-bd15-f4074836b303",
    "storage_key": "property/6767906449165637/019cfb4a-e4bb-754b-bd15-f4074836b303.webp",
    "width": 561,
    "height": 250
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-d8c6-719c-8955-140b9b05beb9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Trace of Ridgeland logo",
    "public_id": "019cfb4b-d8c6-719c-8955-140b9b05beb9",
    "storage_key": "property/6767906449165637/019cfb4b-d8c6-719c-8955-140b9b05beb9.webp",
    "width": 561,
    "height": 250
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-e2df-7459-9e02-db585ba7c7ba.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Trace of Ridgeland logo.",
    "public_id": "019cfb4b-e2df-7459-9e02-db585ba7c7ba",
    "storage_key": "property/6767906449165637/019cfb4b-e2df-7459-9e02-db585ba7c7ba.webp",
    "width": 561,
    "height": 250
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#13545c",
  "property_secondary_color": "#eae0c8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "600 - 1250",
  "property_sqft_min": "600",
  "property_sqft_max": "1250",
  "property_price_range": "1024 - 1484",
  "property_price_min": "1024",
  "property_price_max": "1484",
  "property_available_units": 24,
  "property_facebook_url": "https://www.facebook.com/ArborsAtNatchez/",
  "property_instagram_url": "https://www.instagram.com/thetraceapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJMTW_a1zSKYYRQjs1gJSlsUQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-trace-of-ridgeland-ridgeland-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Trace Apts.",
  "property_home_romance_title": "Experience True Community Living in Your Dream Apartment Home",
  "property_home_amenities_blurb": "Welcome to Trace Apts. in Ridgeland, Mississippi, where comfort meets convenience. Choose from thoughtfully designed one and two-bedroom floor plans, featuring modern kitchens with granite countertops and spacious walk-in closets. Enjoy resort-style amenities like a refreshing pool, inviting courtyard, and on-site management that makes home feel just right.",
  "property_home_floorplans_blurb": "Welcome to Trace Apts. in Ridgeland, Mississippi, where modern living meets comfort. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. With spacious layouts and inviting amenities, your dream apartment awaits. Browse our available homes today and step into your future at Trace Apts.",
  "property_home_gallery_blurb": "Welcome to Trace Apts. in Ridgeland, where comfort meets convenience. Choose from spacious one and two-bedroom floor plans featuring modern kitchens with granite countertops, cozy fireplaces, and inviting courtyards. With amenities like a refreshing pool and on-site management, picture yourself living here and enjoying every moment of home.",
  "property_home_neighborhood_blurb": "At Trace Apts. in Ridgeland, Mississippi, vibrant living meets community charm. Nestled in a prime location, our one and two-bedroom floor plans offer comfort and style. Uncover local favorites and explore nearby attractions that make our neighborhood truly unique. Dive into the exceptional lifestyle waiting just outside your door!",
  "property_home_reviews_blurb": "At Trace Apartments in Ridgeland, Mississippi, residents rave about the care and attentiveness of our friendly staff. With a secure and peaceful atmosphere, one long-term resident shares, “I have no desire to live anywhere else.” Experience community living where comfort and service go hand in hand!",
  "property_neighborhood_blurb": "At Trace Apts. in Ridgeland, Mississippi, vibrant educational opportunities surround you. With esteemed institutions like Tougaloo College and Jackson State University just moments away, your new home combines comfort with a thriving community. Uncover local favorites and engaging activities that make this neighborhood truly special.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience the lifestyle you deserve at Trace Apts. in Ridgeland, Mississippi. Enjoy stunning floor plans, vibrant amenities, and a welcoming atmosphere. Dive into our pool, stay active with racquetball, or unwind on the sundeck. Make every moment count in our thoughtfully designed community, tailored just for you.",
  "property_applynow_blurb": "Welcome to Trace Apts. in Ridgeland, Mississippi, where modern living meets relaxation. Choose from spacious one and two-bedroom floor plans, and enjoy amenities like a sparkling pool, fitness center, and sports courts. Start your journey to comfortable living—lease online today and find your ideal home!",
  "property_contactus_blurb": "At Trace Apts. in Ridgeland, Mississippi, we offer thoughtfully designed floor plans, including spacious one and two-bedroom options tailored to fit your lifestyle. Our welcoming community is just a call away—reach out to our leasing team with any questions or to learn more about your future home!",
  "property_faqs_blurb": "At Trace Apts. in Ridgeland, Mississippi, your ideal living space awaits, whether it's our cozy one-bedroom or spacious two-bedroom floor plans. Our FAQs page is designed to enlighten you about community amenities, leasing details, and more. Dive in and find the answers you need for a seamless transition.",
  "property_floorplans_blurb": "At Trace Apts. in Ridgeland, Mississippi, our thoughtfully designed floor plans cater to every lifestyle. Choose from spacious one or two-bedroom options, each crafted for comfort and convenience. Browse our available apartment homes and envision your ideal living space today! Your perfect floor plan awaits!",
  "property_gallery_blurb": "Welcome to Trace Apts. in Ridgeland, Mississippi—where comfort meets community. Our diverse floor plans include one and two-bedroom apartments, complemented by top-notch amenities like a refreshing pool, fitness center, and racquetball court. Picture yourself relaxing on the sundeck or enjoying a picnic with friends. Live your ideal lifestyle here!",
  "property_interactivemap_blurb": "Welcome to Trace Apts. in Ridgeland, Mississippi, where comfort meets community. Choose from spacious one and two-bedroom floor plans, and enjoy exceptional amenities like our resort-style pool, fitness center, and vibrant recreational courts. Use our interactive community map to find your ideal home today and embrace a lifestyle of convenience and leisure!",
  "property_pets_blurb": "Welcome to Trace Apts in Ridgeland, MS, where comfort meets community. Embrace a vibrant lifestyle in our pet-friendly haven, surrounded by lush landscapes and modern amenities. Reach out to our leasing office for pet policy details and start your journey towards exceptional living today! ",
  "property_referafriend_blurb": "At Trace Apts. in Ridgeland, Mississippi, we believe great friends make great neighbors. With inviting one and two-bedroom floor plans, you’ll thrive in a vibrant community. Share the charm—refer a friend today and enjoy life’s best moments together in your new home!",
  "property_residentaccess_blurb": "At Trace Apts. in Ridgeland, Mississippi, our diverse floor plans, featuring one and two-bedroom options, cater to your unique lifestyle. Seamlessly manage your living experience with easy access to our resident portal—handle rent payments, schedule maintenance, and enjoy more time doing what you love.",
  "property_reviews_blurb": "At Trace Apts. in Ridgeland, Mississippi, residents rave about our attentive staff and thriving community spirit. As one resident puts it, “The new staff in the office is amazing!” With easy access to dining and shopping, it’s the perfect place to call home. See what our residents have to say!",
  "property_created_at": "1753982395448",
  "property_scheduletour_blurb": "At Trace Apts. in Ridgeland, Mississippi, choose from thoughtfully designed one and two-bedroom floor plans that elevate your living experience. Ready to find your perfect home? Schedule a tour today and hear firsthand from our residents about the vibrant community that awaits you!",
  "property_thankyou_blurb": "Thank you for your inquiry about Trace Apts. in beautiful Ridgeland, Mississippi! With thoughtfully designed one and two-bedroom floor plans, your ideal living space awaits. Our friendly team will reach out soon to help you discover your next home sweet home, tailored just for you. Stay tuned!",
  "property_virtualtours_blurb": "Experience the charm of Trace Apts. in Ridgeland, Mississippi, where stylish one and two-bedroom floor plans await. Immerse yourself in a vibrant community and envision your future home. Ready to see for yourself? Take a virtual tour and let Trace Apts. welcome you to your new lifestyle!",
  "property_copyright": "2025 All Rights Reserved. Trace Apts.",
  "property_seo_title_home": "Trace Apts. | Apartments in Ridgeland, Mississippi",
  "property_seo_description_home": "Experience vibrant living at Trace Apts. in Ridgeland, MS. Choose from spacious one and two-bedroom floor plans with top-notch amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Ridgeland, Mississippi",
  "property_seo_description_floorplans": "Elevate your lifestyle at Trace Apts. in Ridgeland, MS! Browse unique one and two-bedroom floor plans designed for comfort and modern living. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Ridgeland, Mississippi Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Trace Apts. in Ridgeland, MS! Dive into luxe amenities like a pool, fitness center, and more—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Ridgeland, Mississippi",
  "property_seo_description_gallery": "\"Immerse yourself in Trace Apts. in Ridgeland, MS! Picture a vibrant lifestyle with stunning amenities, from a sun-soaked pool to active courts and cozy patios!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Trace Apts. Apartments",
  "property_seo_description_virtualtours": "Step inside Trace Apts. in Ridgeland, MS! Experience our stunning one and two-bedroom apartments through a virtual tour. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Trace Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Trace Apts. in Ridgeland! Dive into our amenities, from a pool to racquetball, and explore available options with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Ridgeland, Mississippi",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood around Trace Apts. in Ridgeland, MS! Dive into local favorites and hidden gems just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Trace Apts.",
  "property_seo_description_contact": "Experience modern living at Trace Apts. in Ridgeland, MS. From cozy one-bedroom to spacious two-bedroom floor plans, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Ridgeland, Mississippi",
  "property_seo_description_faqs": "Uncover answers about life at Trace Apts. in Ridgeland! From your ideal floor plan to top amenities, our FAQs page has all you need to know.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Ridgeland, Mississippi",
  "property_seo_description_reviews": "\"Experience life at Trace Apts. in Ridgeland! Dive into resident reviews, and see why our community’s pool, fitness center, and courts make it home sweet home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Ridgeland, Mississippi",
  "property_seo_description_applynow": "Experience the comfort of Trace Apts. in Ridgeland, MS! Choose from one or two-bedroom floor plans with top-notch amenities. Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Trace Apts.",
  "property_seo_description_residentaccess": "Easily manage your lifestyle at Trace Apts. Log in to access payments, maintenance requests, and community updates all in one secure portal!",
  "property_seo_title_referafriend": "Refer A Friend | Trace Apts.",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Trace Apts. in Ridgeland, MS, and enjoy exclusive rewards together in our vibrant community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Trace Apts.",
  "property_seo_description_scheduletour": "Experience the charm of Trace Apts. in Ridgeland, MS. Schedule your tour today and step into a vibrant community tailored for your lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Trace Apts.",
  "property_seo_description_privacy": "Safeguarding your peace of mind at Trace Apts. in Ridgeland, MS. Read our privacy policy to see how we prioritize your privacy and security.",
  "property_seo_title_accessibility": "Website Accessibility | Trace Apts.",
  "property_seo_description_accessibility": "\"At Trace Apts. in Ridgeland, we prioritize accessibility for all. Join our inclusive community where everyone can thrive. Your comfort is our commitment!\"",
  "property_seo_title_sitemap": "Sitemap | Trace Apts.",
  "property_seo_description_sitemap": "Navigate your way to a perfect home at Trace Apts. in Ridgeland, MS. Check out our sitemap for easy access to amenities, floor plans, and community features!",
  "property_seo_title_thankyou": "Thank You | Trace Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Trace Apts in Ridgeland, MS! Your journey to elegant living begins now—expect a prompt response from our friendly team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Ridgeland, MS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866016635",
  "amenities": [
    {
      "id": "ec_726f64c33a25ffbc57a9516b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397341",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_254b2194cf5f55215bf229b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397342",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d40917f129fd2fa01cf1bc63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397344",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c42c87dcd8129df63d588dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397345",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a687265cd04f78a9edc2020",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397346",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6c74300de33d99ad272ab3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397347",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_056d242c4b87ec54c7379df8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397348",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fbaa7171310f6db96ddd22a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127397349",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb1a6713424b5c2f8741decd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "128033154",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6243bb08d2a0fea06c964428",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "128042521",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_202af7c79c4b1063b5549260",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398792",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cefaa3a8a8451f605679b974",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398793",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c393f0da6fed2a5a60394dbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398794",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f18e4f1f982aaa969f783f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398795",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65bfa2cf2a502d2e1e8cd531",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398796",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01a81d5f75a57aaf99ff2de3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398797",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_933d6aea220f37c9445ead9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398798",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd93f04ea774a1a231b4d9d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398799",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74672d31f3c967d4018b4f17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398800",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b66513c4a7c4aac4191a3404",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398801",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_577fd5967e472bacde39459a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398802",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_806c117496a5b082cbf08b4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "yardi",
      "external_id": "127398803",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8f980f8f-45a5-49db-bbd9-55ff0d848bfb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20af-fbc6-745c-accd-8833d8676432.webp",
      "image_media": {
        "alt_text": "Exterior entrance sign reading The Trace with landscaping and a building in the background.",
        "public_id": "019d20af-fbc6-745c-accd-8833d8676432",
        "storage_key": "property/6767906449165637/019d20af-fbc6-745c-accd-8833d8676432.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Community",
      "description": "Exterior view of The Trace apartment community entrance with stone sign, blue logo, and landscaped approach.",
      "link": "",
      "alt_text": "Exterior entrance sign reading The Trace with landscaping and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-b113-7063-a065-9842268ed818.webp"
    },
    {
      "id": "custom_2546ab77-1f87-468a-9eac-a3f8af741f75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20af-fb95-770f-8e01-91116e88399d.webp",
      "image_media": {
        "alt_text": "Exterior entrance to The Trace of Ridgeland apartment community with sign, porch, and trees.",
        "public_id": "019d20af-fb95-770f-8e01-91116e88399d",
        "storage_key": "property/6767906449165637/019d20af-fb95-770f-8e01-91116e88399d.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Community",
      "description": "Exterior view of a welcoming apartment community entrance with a sign, porch, and landscaped grounds.",
      "link": "",
      "alt_text": "Exterior entrance to The Trace of Ridgeland apartment community with sign, porch, and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-af17-704e-ae89-e930844179d7.webp"
    },
    {
      "id": "custom_0bd4ab5a-eff5-4bc6-b485-39db842851f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20af-fb54-7233-9881-b5a60a3c474e.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with a parking lot and trees.",
        "public_id": "019d20af-fb54-7233-9881-b5a60a3c474e",
        "storage_key": "property/6767906449165637/019d20af-fb54-7233-9881-b5a60a3c474e.webp",
        "width": 500,
        "height": 374
      },
      "title": "Community",
      "description": "Exterior view of a multifamily apartment community featuring parking, balconies, and mature trees.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with a parking lot and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165637/019cfb4a-e4bb-754b-bd15-ecbf848fa5ed.webp"
    },
    {
      "id": "custom_9f354b9a-2b40-47cd-96a5-9cbd21709a7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20af-fb50-746c-a963-e0bd73426e91.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with balconies and a central walkway among trees.",
        "public_id": "019d20af-fb50-746c-a963-e0bd73426e91",
        "storage_key": "property/6767906449165637/019d20af-fb50-746c-a963-e0bd73426e91.webp",
        "width": 500,
        "height": 374
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with balconies, a central walkway, and mature trees.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with balconies and a central walkway among trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165637/019cfb4a-e496-76bc-9c2d-81feb7ec1dd7.webp"
    },
    {
      "id": "custom_1a0d1444-cf30-4164-8acc-15fec0ab9385",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-052b-73cf-8ba2-a0334ea75d2e.webp",
      "image_media": {
        "alt_text": "Outdoor pool with wooden deck, lounge chairs, and surrounding trees.",
        "public_id": "019d20b0-052b-73cf-8ba2-a0334ea75d2e",
        "storage_key": "property/6767906449165637/019d20b0-052b-73cf-8ba2-a0334ea75d2e.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Community",
      "description": "Outdoor pool and sun deck among lush trees, ideal for residents to relax.",
      "link": "",
      "alt_text": "Outdoor pool with wooden deck, lounge chairs, and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-b11d-700c-a4ff-43068e282e1d.webp"
    },
    {
      "id": "custom_db0c0f4c-2a8a-4427-a07a-a1c9c4221755",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-07e1-73ef-bdf8-65b424d4dd2a.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with blue lounge chairs and surrounding trees.",
        "public_id": "019d20b0-07e1-73ef-bdf8-65b424d4dd2a",
        "storage_key": "property/6767906449165637/019d20b0-07e1-73ef-bdf8-65b424d4dd2a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor community pool at a multifamily property with wooden deck, lounge chairs, and tall trees.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with blue lounge chairs and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165637/019cfb4a-e4c6-72d9-b24d-19ddc1cb4419.webp"
    },
    {
      "id": "custom_0e4086ef-ed34-44ec-823a-e9235a8c871b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-0b41-77d9-b022-0e137e0cea2e.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and large arched windows.",
        "public_id": "019d20b0-0b41-77d9-b022-0e137e0cea2e",
        "storage_key": "property/6767906449165637/019d20b0-0b41-77d9-b022-0e137e0cea2e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Bright community gym featuring cardio equipment and plenty of natural light from large windows.",
      "link": "",
      "alt_text": "Fitness center with cardio machines and large arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165637/019cfb4a-e4bb-754b-bd15-f1577aa1b0c8.webp"
    },
    {
      "id": "custom_e4e8c096-c6ea-4ca7-b58d-577b5c5dae70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-0cb2-763a-b588-91a6f7557f06.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weights, and mirrors.",
        "public_id": "019d20b0-0cb2-763a-b588-91a6f7557f06",
        "storage_key": "property/6767906449165637/019d20b0-0cb2-763a-b588-91a6f7557f06.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Community",
      "description": "On-site gym at the community with cardio machines, free weights, and mirrored walls.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weights, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-b40a-76c5-abf1-c9c59de84c18.webp"
    },
    {
      "id": "custom_d022e787-ee25-40dd-8ef8-b2769c68c8e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-0fc7-7599-bfba-cdb5208c541f.webp",
      "image_media": {
        "alt_text": "Community laundry room with several front-loading washing machines and dryers.",
        "public_id": "019d20b0-0fc7-7599-bfba-cdb5208c541f",
        "storage_key": "property/6767906449165637/019d20b0-0fc7-7599-bfba-cdb5208c541f.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Community",
      "description": "Shared resident laundry room featuring coin-operated washers and dryers.",
      "link": "",
      "alt_text": "Community laundry room with several front-loading washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-b7c6-758e-873c-6cf333c49dc7.webp"
    },
    {
      "id": "custom_20b1d388-c8a6-4ca9-9c44-c5ed69e69df1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-13eb-77f8-b6aa-02a4b9d5f757.webp",
      "image_media": {
        "alt_text": "Row of white washing machines and dryers in a bright communal laundry room.",
        "public_id": "019d20b0-13eb-77f8-b6aa-02a4b9d5f757",
        "storage_key": "property/6767906449165637/019d20b0-13eb-77f8-b6aa-02a4b9d5f757.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Bright communal laundry room with multiple washers and stacked dryers for residents.",
      "link": "",
      "alt_text": "Row of white washing machines and dryers in a bright communal laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165637/019cfb4a-e4b9-75ec-9308-4c0961ef961b.webp"
    },
    {
      "id": "custom_815c58c4-bac4-441f-bcc2-d5aa0ca3432e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-192f-737d-bed5-47a7e0b8e425.webp",
      "image_media": {
        "alt_text": "Bedroom with teal upholstered bed, nightstand, and blue patterned curtains.",
        "public_id": "019d20b0-192f-737d-bed5-47a7e0b8e425",
        "storage_key": "property/6767906449165637/019d20b0-192f-737d-bed5-47a7e0b8e425.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with turquoise headboard, matching decor, and a large window with blue curtains.",
      "link": "",
      "alt_text": "Bedroom with teal upholstered bed, nightstand, and blue patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a0fa-75c2-be01-3b09fd7db9ff.webp"
    },
    {
      "id": "custom_fd1aa36f-c18d-427f-950d-105e0a7cc101",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-19f6-71bc-be68-1dd99cf60883.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a fireplace, beige sofa, blue accent chair, and windows.",
        "public_id": "019d20b0-19f6-71bc-be68-1dd99cf60883",
        "storage_key": "property/6767906449165637/019d20b0-19f6-71bc-be68-1dd99cf60883.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, neutral sofa, blue accent chair, and decorative accents in a modern apartment.",
      "link": "",
      "alt_text": "Living room in an apartment with a fireplace, beige sofa, blue accent chair, and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a176-7684-a7a5-26e2b89cf28d.webp"
    },
    {
      "id": "custom_8e15d0f2-81cf-416e-9e62-a60b8fa327b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-1b65-754a-80b1-09df986258b2.webp",
      "image_media": {
        "alt_text": "Cozy living room in an apartment with beige carpet, gray sofa, coffee table, and wooden dresser.",
        "public_id": "019d20b0-1b65-754a-80b1-09df986258b2",
        "storage_key": "property/6767906449165637/019d20b0-1b65-754a-80b1-09df986258b2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, inviting living area in a stylish apartment with a gray sofa, coffee table, and a wooden dresser.",
      "link": "",
      "alt_text": "Cozy living room in an apartment with beige carpet, gray sofa, coffee table, and wooden dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a169-7748-9cea-bb102a3e6c11.webp"
    },
    {
      "id": "custom_0690dd5c-37c2-4647-a556-0c048ad7ed0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-2381-742c-86f5-a9885ddc0172.webp",
      "image_media": {
        "alt_text": "Bedroom with a dark upholstered bed, yellow-gray geometric duvet, nightstand, wall art, and vertical blinds.",
        "public_id": "019d20b0-2381-742c-86f5-a9885ddc0172",
        "storage_key": "property/6767906449165637/019d20b0-2381-742c-86f5-a9885ddc0172.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with contemporary decor, featuring a plush bed, decorative pillows, and a balcony door with vertical blinds.",
      "link": "",
      "alt_text": "Bedroom with a dark upholstered bed, yellow-gray geometric duvet, nightstand, wall art, and vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a127-761c-b7f4-df2b86de3928.webp"
    },
    {
      "id": "custom_f1629050-7e6f-4a9f-ae2f-e3207115d45f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-2424-77bb-9838-b7f5e962202b.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with vanity, mirror, toilet, and a bathtub with a white shower curtain.",
        "public_id": "019d20b0-2424-77bb-9838-b7f5e962202b",
        "storage_key": "property/6767906449165637/019d20b0-2424-77bb-9838-b7f5e962202b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior shot of an apartment bathroom with a single vanity, framed art, towel rack, and a white shower curtain.",
      "link": "",
      "alt_text": "Bathroom in an apartment with vanity, mirror, toilet, and a bathtub with a white shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a13b-70ef-a93f-a7ef281a9953.webp"
    },
    {
      "id": "custom_63f65d7c-32fc-4230-b25b-aee21029eecf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-2544-7546-9bea-ad85ea4d1191.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a bed, nightstand, lamp, plant, and sliding glass doors with vertical blinds.",
        "public_id": "019d20b0-2544-7546-9bea-ad85ea4d1191",
        "storage_key": "property/6767906449165637/019d20b0-2544-7546-9bea-ad85ea4d1191.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a modern apartment featuring neutral decor, patterned bedding, a table lamp, and balcony access through sliding doors.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a bed, nightstand, lamp, plant, and sliding glass doors with vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a169-7748-9cea-b5218cc93ea9.webp"
    },
    {
      "id": "custom_db7f0ad3-a059-4936-86b6-e31248ff0090",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-2523-75d4-a266-12f23a30eb95.webp",
      "image_media": {
        "alt_text": "Compact L-shaped kitchen with light wood cabinets, double sink, and white appliances.",
        "public_id": "019d20b0-2523-75d4-a266-12f23a30eb95",
        "storage_key": "property/6767906449165637/019d20b0-2523-75d4-a266-12f23a30eb95.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with a double sink, white stove and fridge, and ample cabinet storage.",
      "link": "",
      "alt_text": "Compact L-shaped kitchen with light wood cabinets, double sink, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a176-7684-a7a5-2b5e27cf4d43.webp"
    },
    {
      "id": "custom_64d45fc5-d773-42e1-a0ad-fea7e40c4924",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-2ee5-7339-a587-27b14617fc58.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity sink, and shower curtain in neutral tones.",
        "public_id": "019d20b0-2ee5-7339-a587-27b14617fc58",
        "storage_key": "property/6767906449165637/019d20b0-2ee5-7339-a587-27b14617fc58.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Well-lit apartment bathroom with a vanity, sink, mirror, and shower/tub combo in a clean, neutral color palette.",
      "link": "",
      "alt_text": "Bathroom with toilet, vanity sink, and shower curtain in neutral tones.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a189-75ce-9cea-e2579259f11f.webp"
    },
    {
      "id": "custom_0ce3b214-733a-4b99-8ae5-a1ae213d8822",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-2eeb-723a-ab42-65a2a1288978.webp",
      "image_media": {
        "alt_text": "Interior living room with beige sofa, blue chair, coffee table, plant, and artwork.",
        "public_id": "019d20b0-2eeb-723a-ab42-65a2a1288978",
        "storage_key": "property/6767906449165637/019d20b0-2eeb-723a-ab42-65a2a1288978.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with neutral tones, plants, and stylish decor.",
      "link": "",
      "alt_text": "Interior living room with beige sofa, blue chair, coffee table, plant, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a195-76cf-a5eb-41b42db9c2ad.webp"
    },
    {
      "id": "custom_38a92710-cd51-49f8-8d4d-ab2a53e20044",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-2fb9-75f6-a8e9-afa7f7f59286.webp",
      "image_media": {
        "alt_text": "Small dining nook with round table, two brown chairs, wall clock, and a kitchen pass-through.",
        "public_id": "019d20b0-2fb9-75f6-a8e9-afa7f7f59286",
        "storage_key": "property/6767906449165637/019d20b0-2fb9-75f6-a8e9-afa7f7f59286.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment dining area with a round table and two brown chairs beside a kitchen pass-through.",
      "link": "",
      "alt_text": "Small dining nook with round table, two brown chairs, wall clock, and a kitchen pass-through.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-a938-76d3-85d5-7f558a703ef3.webp"
    },
    {
      "id": "custom_6deb57ba-6187-4ff5-be7f-a897e92823e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-319f-73aa-b351-591f73b73eae.webp",
      "image_media": {
        "alt_text": "Cozy apartment living room with a gray tufted sofa, chairs, coffee table, and wall art.",
        "public_id": "019d20b0-319f-73aa-b351-591f73b73eae",
        "storage_key": "property/6767906449165637/019d20b0-319f-73aa-b351-591f73b73eae.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A warmly staged living room in a modern apartment with neutral tones, contemporary furnishings, and decorative accents.",
      "link": "",
      "alt_text": "Cozy apartment living room with a gray tufted sofa, chairs, coffee table, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-ae0f-7033-bbe6-2fdcab29f3c6.webp"
    },
    {
      "id": "custom_b32e9895-7cf3-4bbc-874d-e2dfc3371923",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-3876-74d3-9c0b-3a3d507aafcb.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a tub/shower, toilet, and vanity.",
        "public_id": "019d20b0-3876-74d3-9c0b-3a3d507aafcb",
        "storage_key": "property/6767906449165637/019d20b0-3876-74d3-9c0b-3a3d507aafcb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Apartment bathroom featuring a tub/shower, toilet, and vanity with teal towels and leaf artwork.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a tub/shower, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-aea8-7168-ae2f-a1353d9e6f91.webp"
    },
    {
      "id": "custom_9425e44b-3b47-492c-80bd-69388144ba2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-392b-7618-a2c3-3b7afad12cfc.webp",
      "image_media": {
        "alt_text": "Bright kitchen in an apartment with light wood cabinets, white appliances, and a window-seat by two windows.",
        "public_id": "019d20b0-392b-7618-a2c3-3b7afad12cfc",
        "storage_key": "property/6767906449165637/019d20b0-392b-7618-a2c3-3b7afad12cfc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with light wood cabinetry, white stove and refrigerator, and a built-in window seat by large windows.",
      "link": "",
      "alt_text": "Bright kitchen in an apartment with light wood cabinets, white appliances, and a window-seat by two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-ae58-70f2-8781-29a55bcbf651.webp"
    },
    {
      "id": "custom_2a634c01-b173-487a-ae15-3475b2207d62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-3933-7356-b103-8cbaf7fba2e7.webp",
      "image_media": {
        "alt_text": "Living room with beige sectional sofa, fireplace, mounted TV, and dining table near windows.",
        "public_id": "019d20b0-3933-7356-b103-8cbaf7fba2e7",
        "storage_key": "property/6767906449165637/019d20b0-3933-7356-b103-8cbaf7fba2e7.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Spacious model living area with cozy seating, a fireplace, mounted TV, and an open layout.",
      "link": "",
      "alt_text": "Living room with beige sectional sofa, fireplace, mounted TV, and dining table near windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-b103-77ce-9101-a7e6c79d2f10.webp"
    },
    {
      "id": "custom_53903f66-4535-43e6-9ade-bbfcfc8cbd66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d20b0-3b1f-77ab-a4df-96ed1a83a7f3.webp",
      "image_media": {
        "alt_text": "Living room with beige sectional sofa, fireplace, mounted TV, and large windows.",
        "public_id": "019d20b0-3b1f-77ab-a4df-96ed1a83a7f3",
        "storage_key": "property/6767906449165637/019d20b0-3b1f-77ab-a4df-96ed1a83a7f3.webp",
        "width": 1280,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Bright, welcoming living space in a modern apartment featuring a cozy fireplace, rustic wood accents, and ample natural light.",
      "link": "",
      "alt_text": "Living room with beige sectional sofa, fireplace, mounted TV, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-b4fa-71b7-bc46-6327aa4ce995.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_577926a7-e556-456c-a7e4-02c1075b1607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Mama Hamil's Southern Cookin' and Bar B Que Buffet",
      "poi_type": "Restaurants",
      "poi_address": "480 Magnolia St, Madison, MS 39110, USA",
      "poi_short_description": "Spacious buffet chain featuring Southern-style comfort food such as fried chicken and desserts along with a salad bar.",
      "poi_long_description": "People say this barbecue restaurant serves delicious Southern dishes, including fried chicken, ribs, and catfish, as well as a wide variety of vegetables and desserts like peach cobbler and bread pudding. They highlight the generous portions, reasonable prices, and the home-cooked, soul food experience. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-96c1-76e8-be66-9db03b871101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-96c1-76e8-be66-9db03b871101",
        "storage_key": "property/6767906449165637/019d2709-96c1-76e8-be66-9db03b871101.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hamils.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010288085330032935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mama-hamils-southern-cookin-and-bar-b-que-buffet",
      "poi_latitude": "32.444675",
      "poi_longitude": "-90.122784",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-856-4407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5bb-769f-9ec8-043d9df5ab87",
        "storage_key": "property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3jiACfSKYYRJ_nPuK1mzJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_e11f8673-2cc9-4042-ac19-976537f7b640",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "988 Top St, Flowood, MS 39232, USA",
      "poi_short_description": "Family-friendly buffet with an array of American fare, from breakfast to dinner.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including steak, potatoes, fried chicken, and a salad bar. They also highlight the friendly and attentive staff, and the clean atmosphere.\n\nSome reviews mention the food can be lukewarm.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-966f-70b6-b248-dcfa5c5f7f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-966f-70b6-b248-dcfa5c5f7f89",
        "storage_key": "property/6767906449165637/019d2709-966f-70b6-b248-dcfa5c5f7f89.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.goldencorral.com/locations/682/golden-corral-top-street?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=682",
      "poi_directions_map_url": "https://maps.google.com/?cid=5732979269932144382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "32.327924",
      "poi_longitude": "-90.121621",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-420-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5bb-769f-9ec8-043d9df5ab87",
        "storage_key": "property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdgWVRctKIYR_tb7eEWij08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_ad2b04b3-f11c-40f0-86b8-8ac4b208ac9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Shaggy's on the Rez",
      "poi_type": "Restaurants",
      "poi_address": "1733 Spillway Rd, Brandon, MS 39047, USA",
      "poi_short_description": "Popular, lively restaurant and bar serving seafood-inspired fare and featuring outdoor seating with reservoir views.",
      "poi_long_description": "People say this restaurant serves delicious oysters, shrimp, and mahi mahi tacos. They highlight the generous portions, fun atmosphere with live music, and beautiful views of the reservoir. They also like the attentive and friendly service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-969d-72af-b55c-c72a5012f3af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-969d-72af-b55c-c72a5012f3af",
        "storage_key": "property/6767906449165637/019d2709-969d-72af-b55c-c72a5012f3af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shaggys.com/locations/on-the-rez/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606896511369096172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shaggys-on-the-rez",
      "poi_latitude": "32.3882456",
      "poi_longitude": "-90.04912420000001",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-724-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5bb-769f-9ec8-043d9df5ab87",
        "storage_key": "property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJycGXC-nVKYYR7CtEOJWx9K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2ed1160e-396e-437b-8d57-6278714badd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "202 E Layfair Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Counter-serve chicken finger specialist popular for its signature Cane's sauce. Fries and Texas toast come with many of the fried chicken combos.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and fries. They highlight the food is hot and fresh, and the drive-thru is quick. They also like the friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-96c2-763d-b3cc-a7cfff18baa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-96c2-763d-b3cc-a7cfff18baa2",
        "storage_key": "property/6767906449165637/019d2709-96c2-763d-b3cc-a7cfff18baa2.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ms/flowood/202-e.-layfair-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=119709276499798027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.3313599",
      "poi_longitude": "-90.1053988",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 601-933-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5bb-769f-9ec8-043d9df5ab87",
        "storage_key": "property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHz4FBecsKIYRC-gW5vNKqQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c2051ca6-d87c-4a9a-976f-be1968061c0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1873 Main St, Madison, MS 39110, USA",
      "poi_short_description": "Fast-food chain popular for chicken sandwiches and nuggets, along with kids' meals and catering.",
      "poi_long_description": "People say this fast food restaurant offers delicious food and fries. They highlight the convenient locations, children's play space, and fast drive-through. They also like the friendly staff and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-9b2c-761a-8606-e8f2090d4a1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9b2c-761a-8606-e8f2090d4a1c",
        "storage_key": "property/6767906449165637/019d2709-9b2c-761a-8606-e8f2090d4a1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ms/madison-ms?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=417678638787326989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.46803",
      "poi_longitude": "-90.1307161",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-898-2338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5bb-769f-9ec8-043d9df5ab87",
        "storage_key": "property/6767906449165637/019d2709-c5bb-769f-9ec8-043d9df5ab87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6QgS5XRKYYRDfQvT4LkywU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_95bf738b-9433-4e0d-be3b-18fd38256b2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Northpark",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Climate-controlled mall with 120+ shops, a food court, an arcade, and a play area.",
      "poi_long_description": "People say this shopping center offers a variety of shops and dining options, including American Deli and Belk. They also highlight the friendly staff and safe environment.\n\nOther reviews mention there can be leaks from the ceiling.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-9b2d-74fd-83f3-36aef35e2678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9b2d-74fd-83f3-36aef35e2678",
        "storage_key": "property/6767906449165637/019d2709-9b2d-74fd-83f3-36aef35e2678.webp",
        "width": 1280,
        "height": 819
      },
      "poi_business_url": "http://www.visitnorthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14074278564042696477&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northpark",
      "poi_latitude": "32.4030556",
      "poi_longitude": "-90.1291667",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-863-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5e1-76dd-9a4f-282b6ed2efda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5e1-76dd-9a4f-282b6ed2efda",
        "storage_key": "property/6767906449165637/019d2709-c5e1-76dd-9a4f-282b6ed2efda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhY9vW4rSKYYRHeeoB8nhUcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b45e4f1b-6565-40ac-bea6-8e0a368f8f27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4500 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Upscale store selling organic foods (including grass-fed meats) as well as baked goods, flowers, seafood and salads along with prepared items.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, specialty items, and a hot bar with a variety of options. They highlight the reasonable prices for the buffet and the clean, well-organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-9c57-7798-871c-0b7eb1f45105.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9c57-7798-871c-0b7eb1f45105",
        "storage_key": "property/6767906449165637/019d2709-9c57-7798-871c-0b7eb1f45105.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/jkn?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173301360047794626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.3543087",
      "poi_longitude": "-90.1502174",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-608-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5f3-7309-8991-b4a1857c4fd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5f3-7309-8991-b4a1857c4fd2",
        "storage_key": "property/6767906449165637/019d2709-c5f3-7309-8991-b4a1857c4fd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8w7oKoyKIYRwqnRtMr30LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_65ad67b2-0199-4dd6-a926-5d78d00a3ef2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4910 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers a wide variety of products. They also highlight the staff can be helpful and friendly.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-9d11-700f-b4bf-e677d7de87ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9d11-700f-b4bf-e677d7de87ba",
        "storage_key": "property/6767906449165637/019d2709-9d11-700f-b4bf-e677d7de87ba.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ms/jackson/jacksonian-plaza/025/00345?cid=loc_02500345_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562485936542992699&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.3637911",
      "poi_longitude": "-90.1479131",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-366-1141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5f3-7309-8991-b4a1857c4fd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5f3-7309-8991-b4a1857c4fd2",
        "storage_key": "property/6767906449165637/019d2709-c5f3-7309-8991-b4a1857c4fd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_-AxKsyKIYRO0l8f2bqVq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6dfaab79-e857-455f-b1ea-2324fb317a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "120 Ridge Way, Flowood, MS 39232, USA",
      "poi_short_description": "Hardware and appliance retailer, offering installation and repair services plus flooring, paint, rugs, and plants.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a01c-7478-bef3-de827b8de29b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a01c-7478-bef3-de827b8de29b",
        "storage_key": "property/6767906449165637/019d2709-a01c-7478-bef3-de827b8de29b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MS-Flowood/2553?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2553-_-na-_-0-_-0&y_source=1_MTE4MzYzNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9943658338956026944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.3408446",
      "poi_longitude": "-90.0714649",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-992-8475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5e1-76dd-9a4f-282b6ed2efda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5e1-76dd-9a4f-282b6ed2efda",
        "storage_key": "property/6767906449165637/019d2709-c5e1-76dd-9a4f-282b6ed2efda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOQyEcrKIYRQCRTVZP4_ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f3fd585d-cf44-41dc-aac5-e1a0af1ba9a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Renaissance at Colony Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "Open-air retail center with a European design theme, featuring fountains and lush landscaping.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and restaurants. They highlight the clean and well-maintained environment, and the beautiful fountains and water show. They also like the safe and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a089-71e6-8f1b-a8d6ae369ed8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a089-71e6-8f1b-a8d6ae369ed8",
        "storage_key": "property/6767906449165637/019d2709-a089-71e6-8f1b-a8d6ae369ed8.webp",
        "width": 701,
        "height": 396
      },
      "poi_business_url": "https://renaissanceatcolonypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1390767190390103411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renaissance-at-colony-park",
      "poi_latitude": "32.4356677",
      "poi_longitude": "-90.1465128",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-519-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5e1-76dd-9a4f-282b6ed2efda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5e1-76dd-9a4f-282b6ed2efda",
        "storage_key": "property/6767906449165637/019d2709-c5e1-76dd-9a4f-282b6ed2efda.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr8vq_wjSKYYRc114HGT_TBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9aee7c44-8e55-4a31-a018-885640d0fc09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Holmes Community College",
      "poi_type": "Education",
      "poi_address": "412 W Ridgeland Ave, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a1a6-7747-95d1-f27abacfa2cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a1a6-7747-95d1-f27abacfa2cb",
        "storage_key": "property/6767906449165637/019d2709-a1a6-7747-95d1-f27abacfa2cb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://holmescc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907095702532732739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "holmes-community-college",
      "poi_latitude": "32.4371517",
      "poi_longitude": "-90.1391745",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-856-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5ba-77ca-94aa-a71003812d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a71003812d69",
        "storage_key": "property/6767906449165637/019d2709-c5ba-77ca-94aa-a71003812d69.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RKR5BrSKYYRQzcXM_Lu2l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_277be6f3-1b11-4b0d-bac5-4481b01b14a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Tougaloo College",
      "poi_type": "Education",
      "poi_address": "500 W County Line Rd, Tougaloo, MS 39174, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a1ac-72ba-8bcb-93f39c383599.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a1ac-72ba-8bcb-93f39c383599",
        "storage_key": "property/6767906449165637/019d2709-a1ac-72ba-8bcb-93f39c383599.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tougaloo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573720754771851030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tougaloo-college",
      "poi_latitude": "32.4048193",
      "poi_longitude": "-90.160845",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-977-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c5ba-77ca-94aa-a71003812d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a71003812d69",
        "storage_key": "property/6767906449165637/019d2709-c5ba-77ca-94aa-a71003812d69.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJewwN-pzNKYYRFve9zbQdnqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d9bf669b-e249-4274-83f0-de84feea508e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Mississippi Museum of Natural Science",
      "poi_type": "Entertainment",
      "poi_address": "2148 Riverside Dr, Jackson, MS 39202, USA",
      "poi_short_description": "Aquariums, fossils and dinosaurs are featured at this kid-friendly museum, which also has stuffed displays.",
      "poi_long_description": "People say this museum offers a variety of exhibits, including fossils, aquariums, and live animals such as turtles, alligators, and fish. They highlight the fun nature trails with life-sized dinosaurs, the outdoor playground, and the kid-friendly atmosphere. They also like the reasonable admission price and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a467-7170-8505-e8eb5b4a4bfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a467-7170-8505-e8eb5b4a4bfb",
        "storage_key": "property/6767906449165637/019d2709-a467-7170-8505-e8eb5b4a4bfb.webp",
        "width": 1204,
        "height": 804
      },
      "poi_business_url": "https://www.mdwfp.com/museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=9206655217532860533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mississippi-museum-of-natural-science",
      "poi_latitude": "32.3249191",
      "poi_longitude": "-90.1572274",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-576-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c97a-74ed-994f-4f8c1e25208e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c97a-74ed-994f-4f8c1e25208e",
        "storage_key": "property/6767906449165637/019d2709-c97a-74ed-994f-4f8c1e25208e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6VeP5AyKIYRdfiKMiScxH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3232a087-f1cb-4c7c-8691-c3e9b4b652fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Mississippi Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "2145 Museum Blvd, Jackson, MS 39202, USA",
      "poi_short_description": "Children's museum offering educational, interactive exhibits and programs.",
      "poi_long_description": "People say this children's museum offers a multi-sensory experience with engaging exhibits, a splash pad, and a unique playground. They highlight the membership provides ongoing access and the tickets are affordable. They also like the educational and interactive play areas, and the fun, interactive events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a4af-705d-adf4-35a7ac438241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a4af-705d-adf4-35a7ac438241",
        "storage_key": "property/6767906449165637/019d2709-a4af-705d-adf4-35a7ac438241.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://mschildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9429186362770771731&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mississippi-childrens-museum",
      "poi_latitude": "32.32870030000001",
      "poi_longitude": "-90.1571926",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-981-5469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c97a-74ed-994f-4f8c1e25208e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c97a-74ed-994f-4f8c1e25208e",
        "storage_key": "property/6767906449165637/019d2709-c97a-74ed-994f-4f8c1e25208e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJffLKlpkyKIYRE8_o-Qkz24I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_faf7e6d1-8b86-4ad0-9118-ed55de3050c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "6370 Ridgewood Ct Dr, Jackson, MS 39211, USA",
      "poi_short_description": "Trampoline park featuring multiple jumping areas, plus go-karts, arcade games and a zip line.",
      "poi_long_description": "People say this amusement park offers a variety of exciting activities, including trampolines, go-karts, bumper cars, and a zip line. They highlight the fun, family-friendly atmosphere and the spacious layout with plenty of activities for kids. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a670-77cb-be5c-7d26fe3343d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a670-77cb-be5c-7d26fe3343d5",
        "storage_key": "property/6767906449165637/019d2709-a670-77cb-be5c-7d26fe3343d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/mississippi-jackson/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3514114226054270296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.3958583",
      "poi_longitude": "-90.1364822",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-566-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9gZoZjTKYYRWI0cIEWkxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_d6df23b3-8123-4256-9ca2-19aa957dc9c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "2000 E County Line Rd Suite B, Ridgeland, MS 39157, USA",
      "poi_short_description": "Bounce-filled amusement center featuring a trampoline park with dodgeball and basketball courts, plus arcade games.",
      "poi_long_description": "People say this amusement park offers a fun experience for kids and birthday parties. They also highlight the professional and friendly staff, and the positive and welcoming atmosphere.\n\nOther reviews mention the food can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a71a-71d8-a4ca-6000f7cf1f34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a71a-71d8-a4ca-6000f7cf1f34",
        "storage_key": "property/6767906449165637/019d2709-a71a-71d8-a4ca-6000f7cf1f34.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.skyzone.com/ridgeland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573673565696973962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "32.400928",
      "poi_longitude": "-90.109942",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-899-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8_ZewDTKYYRilxCW5jNINg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_0e306adc-e023-4ce0-9bad-531b89d8ca26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Mississippi Agriculture and Forestry Museum",
      "poi_type": "Entertainment",
      "poi_address": "1150 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "A living-history farm, a recreated 1920s cotton-economy-era town & local historical artifacts.",
      "poi_long_description": "Visitors say this museum features antique equipment, tools, cars, and planes, as well as a recreated old town with a doctor's office, gas station, and schoolhouse. They also highlight the special events, such as the Pickle Festival and pumpkin patch, that the museum hosts throughout the year.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-a8c0-7764-a28b-34bd7748d1a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a8c0-7764-a28b-34bd7748d1a1",
        "storage_key": "property/6767906449165637/019d2709-a8c0-7764-a28b-34bd7748d1a1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.msagmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7687106239260140894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mississippi-agriculture-and-forestry-museum",
      "poi_latitude": "32.3366165",
      "poi_longitude": "-90.1577225",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-432-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c97a-74ed-994f-4f8c1e25208e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c97a-74ed-994f-4f8c1e25208e",
        "storage_key": "property/6767906449165637/019d2709-c97a-74ed-994f-4f8c1e25208e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yEzu6IyKIYRXiXKhWUWrmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_00e9dc2e-ec6c-4d43-b7b4-42728cd4e8cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "772 Lake Harbour Dr # 1, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clean gym chain featuring a cardio area, weight machines and a 24-hour schedule.",
      "poi_long_description": "People say this gym has a wide variety of well-maintained equipment, including treadmills, ellipticals, bikes, rowing machines, and weight machines, and they appreciate the spacious layout. They also highlight the friendly and helpful staff, and the clean and well-lit facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-aa2b-71a3-8914-8a1525deb553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aa2b-71a3-8914-8a1525deb553",
        "storage_key": "property/6767906449165637/019d2709-aa2b-71a3-8914-8a1525deb553.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/ridgeland-ms?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17295786995903098070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.4155597",
      "poi_longitude": "-90.1107937",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-427-5901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSGVmpnTKYYR1uyfwaL6BvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_19b2fb19-29b4-481c-9683-e5fda04f8320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "175 Grandview Blvd, Madison, MS 39110, USA",
      "poi_short_description": "Chain specializing in cosmetics, hair products and skincare items.",
      "poi_long_description": "People say this cosmetics store offers great customer service with helpful and friendly staff. They also highlight that customers can find everything they need.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-aaf5-708d-bf4f-bc9595ef701b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aaf5-708d-bf4f-bc9595ef701b",
        "storage_key": "property/6767906449165637/019d2709-aaf5-708d-bf4f-bc9595ef701b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/madison-ms-477",
      "poi_directions_map_url": "https://maps.google.com/?cid=14503229940897169379&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "32.4648393",
      "poi_longitude": "-90.1350921",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-856-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_wdLgHdKIYR4z_8MsrSRck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_efb5acdf-a290-4270-ad75-4771f90f893f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "GRIT Training",
      "poi_type": "Health and Wellness",
      "poi_address": "2625 Courthouse Cir, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, including a batting cage, workout field, pool, basketball court, free weights, and machines. They highlight the spacious layout, cool vibe, and excellent equipment. They also like the friendly staff and clean, safe, family environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-acfd-757a-8549-c12aac724938.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-acfd-757a-8549-c12aac724938",
        "storage_key": "property/6767906449165637/019d2709-acfd-757a-8549-c12aac724938.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.grit-ms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2231842918902481768&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grit-training",
      "poi_latitude": "32.3272575",
      "poi_longitude": "-90.1152147",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-487-2443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6cx-GwtKIYRaEOnV08Z-R4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_6644cbdd-1f49-4d06-b5d9-026933ab1a4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Animal Emergency & Referral Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1009 Treetops Blvd, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-adad-715c-b2a3-c87198891dba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-adad-715c-b2a3-c87198891dba",
        "storage_key": "property/6767906449165637/019d2709-adad-715c-b2a3-c87198891dba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cvm.msstate.edu/aerc-home",
      "poi_directions_map_url": "https://maps.google.com/?cid=12162414471896174386&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency--referral-center",
      "poi_latitude": "32.3255648",
      "poi_longitude": "-90.1194963",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-939-8999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzq8QxotKIYRMg9x4IWTyag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_d21ebf24-319b-4cb7-861c-194d3a891a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "CLUB4 Fitness Lake Harbour",
      "poi_type": "Health and Wellness",
      "poi_address": "511 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Membership-only gym offering equipment, classes, child care, a pool, and a rock climbing wall.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, classes, and instructors, and is a great place to achieve fitness goals. They also highlight the friendly staff, clean facility, and reasonable membership prices.\n\nOther reviews mention the lockers can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-aebc-723e-848d-031667aa5dbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aebc-723e-848d-031667aa5dbf",
        "storage_key": "property/6767906449165637/019d2709-aebc-723e-848d-031667aa5dbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.club4fitness.com/location/lake-harbour/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6318120847339163222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club4-fitness-lake-harbour",
      "poi_latitude": "32.4133465",
      "poi_longitude": "-90.1175495",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-605-9886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTFhXUPSKYYRVg6kkW95rlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_262f3760-518a-4fbb-9247-37b9521aea46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Crunch Fitness - Ridgeland",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Fitness center featuring various classes (including spinning), treadmills, weights and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-af8a-7088-8f44-c124ef8f7f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-af8a-7088-8f44-c124ef8f7f1a",
        "storage_key": "property/6767906449165637/019d2709-af8a-7088-8f44-c124ef8f7f1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/ridgeland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16000032341730509397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---ridgeland",
      "poi_latitude": "32.4010391",
      "poi_longitude": "-90.1096038",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-360-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfpJ8fjSKYYRVcKbm6SIC94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_79cb11ee-99cf-4dd8-98ee-5da394b41cf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Flowood - Lakeland Drive",
      "poi_type": "Health and Wellness",
      "poi_address": "163 Ridge Way E, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b249-7089-b72a-7febb0f97606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b249-7089-b72a-7febb0f97606",
        "storage_key": "property/6767906449165637/019d2709-b249-7089-b72a-7febb0f97606.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-ms-flowood-ms101?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9886910044159362539&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-flowood---lakeland-drive",
      "poi_latitude": "32.3395694",
      "poi_longitude": "-90.0703666",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-992-2733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfbKwFsrKIYR60VcVE1cNYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_6e405e08-0487-43b3-8643-89bdb40a63b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Ancee Nail Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 Lakeland Dr # E10, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b2c9-72eb-9d1f-dcccf71b60d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b2c9-72eb-9d1f-dcccf71b60d6",
        "storage_key": "property/6767906449165637/019d2709-b2c9-72eb-9d1f-dcccf71b60d6.webp",
        "width": 1173,
        "height": 1280
      },
      "poi_business_url": "https://anceenaillounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11516596813459570638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ancee-nail-lounge",
      "poi_latitude": "32.3331343",
      "poi_longitude": "-90.1396647",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-368-6868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1nZRQwtKIYRzj-nx8gr058",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_b8d9cc06-20ad-47f2-8be7-e56e6dc7377b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "St. Dominic Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "969 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b3d3-72db-b76c-386ea2eb52f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b3d3-72db-b76c-386ea2eb52f8",
        "storage_key": "property/6767906449165637/019d2709-b3d3-72db-b76c-386ea2eb52f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fmolhs.org/locations/greater-jackson/st-dominics-hospital?utm_source=Google&utm_medium=listing&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=2322937810740476467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-dominic-hospital",
      "poi_latitude": "32.3326096",
      "poi_longitude": "-90.1653002",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-200-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9da-750d-bd10-d6996906cda1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9da-750d-bd10-d6996906cda1",
        "storage_key": "property/6767906449165637/019d2709-c9da-750d-bd10-d6996906cda1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYdRlJUyKIYRM3qCpKG7PCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1638e690-67f1-4a75-8c85-5c3eeb01948a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Merit Health River Oaks",
      "poi_type": "Health and Wellness",
      "poi_address": "1030 River Oaks Dr, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b4b1-76ac-85b8-267b217fda62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b4b1-76ac-85b8-267b217fda62",
        "storage_key": "property/6767906449165637/019d2709-b4b1-76ac-85b8-267b217fda62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.merithealthriveroaks.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11758755380568636959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "merit-health-river-oaks",
      "poi_latitude": "32.3255013",
      "poi_longitude": "-90.1052711",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 601-932-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9da-750d-bd10-d6996906cda1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9da-750d-bd10-d6996906cda1",
        "storage_key": "property/6767906449165637/019d2709-c9da-750d-bd10-d6996906cda1.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdk8UuQsKIYRH76B07d9L6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5328cd28-eb57-4d86-a1af-b97ca21d79ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "LeFleur's Bluff State Park Mayes Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3315 Lakeland Terrace, Jackson, MS 39216, USA",
      "poi_short_description": "State park offering hiking, disc golf, a playground, and campgrounds, plus a natural science museum.",
      "poi_long_description": "People say this state park offers a campground, fishing, and trails, and is conveniently located near the city. They highlight the affordable prices, quiet and peaceful vibe, and the opportunity to see wildlife. They also like the friendly staff and the well-maintained bathrooms with free showers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b75a-77f1-9142-23a947489ba7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b75a-77f1-9142-23a947489ba7",
        "storage_key": "property/6767906449165637/019d2709-b75a-77f1-9142-23a947489ba7.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.mdwfp.com/parks-destinations/park/lefleurs-bluff-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18333674287180082174&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lefleurs-bluff-state-park-mayes-lake",
      "poi_latitude": "32.3308055",
      "poi_longitude": "-90.1489668",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-987-3923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9b0-736a-b29e-89020207ee10",
        "storage_key": "property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTspAmItKIYR_usU06BLbv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_9079b6e8-9267-41c8-90a1-be05806a8a30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Freedom Ridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "253 W School St, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clean sports-facility park featuring a softball field and a playground.",
      "poi_long_description": "People say this park is very big and fun for kids, and also great for soccer games. They highlight the clean and friendly environment, and the easy access between fields. They also like that it's safe. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b805-705d-a6c0-1b8ada4155bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b805-705d-a6c0-1b8ada4155bb",
        "storage_key": "property/6767906449165637/019d2709-b805-705d-a6c0-1b8ada4155bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridgelandms.org/city-departments/recreation-and-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15546985984956168474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freedom-ridge",
      "poi_latitude": "32.4197477",
      "poi_longitude": "-90.1413081",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9b0-736a-b29e-89020207ee10",
        "storage_key": "property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSKa83HSKYYRGvlJwWH9wdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6f9481d-3289-48d7-910b-0c5c1593195f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Winners Circle Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Winners Cir, Flowood, MS 39232, USA",
      "poi_short_description": "Clean recreation area featuring a playground, tennis courts, barbecue grills and walking paths.",
      "poi_long_description": "Visitors say this park has well-maintained playgrounds and tennis courts, and they appreciate the beautiful nature. They also highlight that the playground is suitable for all ages, making it a great spot for families with young children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b893-732d-896f-85cad030fce4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b893-732d-896f-85cad030fce4",
        "storage_key": "property/6767906449165637/019d2709-b893-732d-896f-85cad030fce4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofflowood.com/winner%E2%80%99s-circle-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4454325228718501489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winners-circle-park",
      "poi_latitude": "32.3470087",
      "poi_longitude": "-90.0625008",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-992-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9b0-736a-b29e-89020207ee10",
        "storage_key": "property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9jH-04rKIYRca7TCzLx0D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e456d4ed-6749-4c9d-8a34-28b5e8823c08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Old Trace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "422 Post Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Park with a playground, picnic areas, restrooms, walking trails, and a disc golf course.",
      "poi_long_description": "People say this park offers a beautiful view of the reservoir. They highlight the dog park and walking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-b9d8-7522-99d1-4d73d3358995.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b9d8-7522-99d1-4d73d3358995",
        "storage_key": "property/6767906449165637/019d2709-b9d8-7522-99d1-4d73d3358995.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.therez.ms.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671602723425758356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-trace-park",
      "poi_latitude": "32.4274039",
      "poi_longitude": "-90.0823689",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9b0-736a-b29e-89020207ee10",
        "storage_key": "property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfITFPPTKYYRlCzCroVwEyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e0d3ea1d-acc0-41d7-b953-a54126e4ea08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Flowood Liberty Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Unnamed Road, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-bbe7-727d-87f5-8dc5d0066c62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bbe7-727d-87f5-8dc5d0066c62",
        "storage_key": "property/6767906449165637/019d2709-bbe7-727d-87f5-8dc5d0066c62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8220269399056143777&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flowood-liberty-park",
      "poi_latitude": "32.3464135",
      "poi_longitude": "-90.0864976",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9b0-736a-b29e-89020207ee10",
        "storage_key": "property/6767906449165637/019d2709-c9b0-736a-b29e-89020207ee10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0z5Z5wtKIYRoVXBMHdDFHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3f341d36-4c2c-432c-a4ca-19b79a5548fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Bruce Campbell Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-bd36-755a-a55e-765552817b36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bd36-755a-a55e-765552817b36",
        "storage_key": "property/6767906449165637/019d2709-bd36-755a-a55e-765552817b36.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.madisonthecity.com/government/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202379395653693271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bruce-campbell-field",
      "poi_latitude": "32.4400825",
      "poi_longitude": "-90.1052932",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-cd7f-761c-bf8e-a19738c8b346.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cd7f-761c-bf8e-a19738c8b346",
        "storage_key": "property/6767906449165637/019d2709-cd7f-761c-bf8e-a19738c8b346.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRqzhNDTKYYRV-9P1k1rtX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_61f7f844-d933-4da6-8cee-73678197d840",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Madison Air LLC.",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-bdc4-7194-868f-7e635fa4b475.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bdc4-7194-868f-7e635fa4b475",
        "storage_key": "property/6767906449165637/019d2709-bdc4-7194-868f-7e635fa4b475.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11203969235679198100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-air-llc",
      "poi_latitude": "32.4401776",
      "poi_longitude": "-90.1051652",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-cd7f-761c-bf8e-a19738c8b346.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cd7f-761c-bf8e-a19738c8b346",
        "storage_key": "property/6767906449165637/019d2709-cd7f-761c-bf8e-a19738c8b346.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYe6J9HTKYYRlDsQn6h-fJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_42eac250-3f64-4327-833c-bf81849fd313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "The Powerhouse, Entergy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Echelon Pkwy, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-bf7f-735c-aa13-1734342d55c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bf7f-735c-aa13-1734342d55c8",
        "storage_key": "property/6767906449165637/019d2709-bf7f-735c-aa13-1734342d55c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8770278893550025776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-powerhouse-entergy",
      "poi_latitude": "32.396321",
      "poi_longitude": "-90.191046",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-952-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaisuv7MKYYRMLwnzy9Ktnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5b8e9b67-df00-4417-9343-d761b54047cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Entergy Transmission HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6540 Watkins Dr, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c1ba-721d-8667-2e0e6f0acbfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c1ba-721d-8667-2e0e6f0acbfb",
        "storage_key": "property/6767906449165637/019d2709-c1ba-721d-8667-2e0e6f0acbfb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://entergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1578563261303676078&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "entergy-transmission-hq",
      "poi_latitude": "32.3975051",
      "poi_longitude": "-90.1912372",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2H9zv7MKYYRrtx8Lewu6BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c553b728-8e15-439c-af64-d6c512b3d0e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "C Spire Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1018 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c157-759b-9afb-dc9b6da154d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c157-759b-9afb-dc9b6da154d9",
        "storage_key": "property/6767906449165637/019d2709-c157-759b-9afb-dc9b6da154d9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.cspire.com/business",
      "poi_directions_map_url": "https://maps.google.com/?cid=8383002471184058399&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "c-spire-corporate-headquarters",
      "poi_latitude": "32.437348",
      "poi_longitude": "-90.147231",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 866-455-9628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0s2rPXTKYYRH8glHlVoVnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c199df87-a948-413f-aaf1-4070b3d0db4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "WIS International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "405 Briarwood Dr Ste 204, Jackson, MS 39206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=723603429317288698&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wis-international",
      "poi_latitude": "32.3788088",
      "poi_longitude": "-90.1517332",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-957-0181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-630XmDNKYYR-iK2MnzBCgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b31ef8c2-4a06-4590-a34a-c910b27e333e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "MDHS- Child Support Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "950 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mdhs.ms.gov/child-support/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1738695405663311359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mdhs--child-support-services",
      "poi_latitude": "32.4004974",
      "poi_longitude": "-90.1374969",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-359-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9c2-701f-a0bb-9ce8d6fef1e0",
        "storage_key": "property/6767906449165637/019d2709-c9c2-701f-a0bb-9ce8d6fef1e0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu1njEqnTKYYR_1Uqa0IWIRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_89a1f959-757f-41b5-9cdf-d560fd330d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Ann Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "306 S Pear Orchard Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-7764-700e-90d9-0762baf749c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7764-700e-90d9-0762baf749c3",
        "storage_key": "property/6767906449165637/019d7913-7764-700e-90d9-0762baf749c3.webp",
        "width": 533,
        "height": 400
      },
      "poi_business_url": "http://www.madison-schools.com/ase",
      "poi_directions_map_url": "https://maps.google.com/?cid=2820663062739685371&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ann-smith-elementary-school",
      "poi_latitude": "32.420476",
      "poi_longitude": "-90.1220605",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-856-6621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40cd-7565-b33b-93621728fb6a",
        "storage_key": "property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6yCSN0bSKYYR-w-qbRwCJSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f9d6b36d-1e2a-428d-a8a8-7387d176a562",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Highland Elementary School",
      "poi_type": "Education",
      "poi_address": "330 Brame Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.madison-schools.com/hes",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494384500546725945&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highland-elementary-school",
      "poi_latitude": "32.4161238",
      "poi_longitude": "-90.1505377",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-853-8103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40cd-7565-b33b-93621728fb6a",
        "storage_key": "property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJddIAM4rNKYYROehnSJwcB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_18248079-bddf-427d-b5db-353ccc6a995a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Ridgeland High School",
      "poi_type": "Education",
      "poi_address": "586 Sunnybrook Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-7726-716c-b7f7-81da829a0941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7726-716c-b7f7-81da829a0941",
        "storage_key": "property/6767906449165637/019d7913-7726-716c-b7f7-81da829a0941.webp",
        "width": 440,
        "height": 400
      },
      "poi_business_url": "https://rhs.madison-schools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3513983871240866136&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgeland-high-school",
      "poi_latitude": "32.4445543",
      "poi_longitude": "-90.1360819",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-898-5023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40cd-7565-b33b-93621728fb6a",
        "storage_key": "property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOYANuB3SKYYRWInDh7YtxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_cdfd5e61-0171-4a32-80e2-5ff465ba5edf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Callaway High School",
      "poi_type": "Education",
      "poi_address": "601 Beasley Rd, Jackson, MS 39206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jackson.k12.ms.us/callaway",
      "poi_directions_map_url": "https://maps.google.com/?cid=15973602223734912220&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "callaway-high-school",
      "poi_latitude": "32.3848112",
      "poi_longitude": "-90.1717685",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 769-228-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40cd-7565-b33b-93621728fb6a",
        "storage_key": "property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJowECEOLMKYYR3PQbOZeird0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_815a9cc8-bd40-41a5-b128-d4697b325417",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "St Andrew's Episcopal School- North Campus",
      "poi_type": "Education",
      "poi_address": "370 Old Agency Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-772b-7376-9d91-c8bcb4cd001e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-772b-7376-9d91-c8bcb4cd001e",
        "storage_key": "property/6767906449165637/019d7913-772b-7376-9d91-c8bcb4cd001e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.gosaints.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2185204927122039813&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "st-andrew-s-episcopal-school-north-campus",
      "poi_latitude": "32.4353536",
      "poi_longitude": "-90.1501893",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-853-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40cd-7565-b33b-93621728fb6a",
        "storage_key": "property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT6i4tQ7SKYYRBeSKsk1oUx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_92df6a8b-42e1-478c-828b-b49810370be8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Madison-Ridgeland Academy",
      "poi_type": "Education",
      "poi_address": "7601 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-7ad1-75fb-9f24-4464a47f14cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7ad1-75fb-9f24-4464a47f14cf",
        "storage_key": "property/6767906449165637/019d7913-7ad1-75fb-9f24-4464a47f14cf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mrapats.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2045383793945594452&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "madison-ridgeland-academy",
      "poi_latitude": "32.448796",
      "poi_longitude": "-90.1078276",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-856-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40cd-7565-b33b-93621728fb6a",
        "storage_key": "property/6767906449165637/019cfb4b-40cd-7565-b33b-93621728fb6a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOfSIDXzRKYYRVMp3Q7mpYhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_31b30fe2-5a3d-47b2-a5cd-d8a8b5547f76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Dogmud Tavern",
      "poi_type": "Restaurants",
      "poi_address": "681 S Pear Orchard Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed tavern with a \"gamers-den\" atmosphere playing movie and video game tunes.",
      "poi_long_description": "People say this restaurant offers excellent pizza, homemade food, and a fun menu with a wide variety of options. They highlight the cool, geek-chic atmosphere with board games and fun events, and the interesting drink menu. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-8756-7772-9a01-fa18e650fd7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8756-7772-9a01-fa18e650fd7c",
        "storage_key": "property/6767906449165637/019d7913-8756-7772-9a01-fa18e650fd7c.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.dogmudtavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15134428375144976873&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dogmud-tavern",
      "poi_latitude": "32.4066531",
      "poi_longitude": "-90.1241092",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-499-4932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40ba-7684-986a-7a4135bf2f90",
        "storage_key": "property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJswZ4xdTTKYYR6dEb62tKCNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3161db9b-17cd-49fc-ad7c-18f04652f721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Primos Cafe",
      "poi_type": "Restaurants",
      "poi_address": "515 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Casual restaurant serving Southern American fare in diner-like digs with a bakery counter.",
      "poi_long_description": "People say this restaurant offers delicious food, including burgers, fries, and sweet tea, and a wide variety of bakery items. They also highlight the friendly and helpful staff, and the clean and spacious atmosphere.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-8434-7510-b17f-c4ed5dd70519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8434-7510-b17f-c4ed5dd70519",
        "storage_key": "property/6767906449165637/019d7913-8434-7510-b17f-c4ed5dd70519.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.primoscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4860481428203367308&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "primos-cafe",
      "poi_latitude": "32.4136154",
      "poi_longitude": "-90.1166822",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-898-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40ba-7684-986a-7a4135bf2f90",
        "storage_key": "property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2W7EC07SKYYRjOtxZRvmc0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7b745962-3ad8-4be7-b3b6-47f28d4e62f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "316 US-51, Ridgeland, MS 39157, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "People say this fast food restaurant offers milkshakes.\n\nOther reviews mention the service can be slow and the staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-836f-764b-90a6-cac4e1d0ba7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-836f-764b-90a6-cac4e1d0ba7c",
        "storage_key": "property/6767906449165637/019d7913-836f-764b-90a6-cac4e1d0ba7c.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/ms/ridgeland/316-highway-51/store-3541?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg0OTk4Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9538555803454089605&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "32.4155052",
      "poi_longitude": "-90.1374735",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-898-9909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40ba-7684-986a-7a4135bf2f90",
        "storage_key": "property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7f__W7SKYYRhSkfP_fBX4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3330a6c9-2abb-4d7f-9665-bca02529e14a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Amerigo Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6592 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Local chain outlet with a full bar & a menu of classic Italian dishes in an easygoing atmosphere.",
      "poi_long_description": "People say this Italian restaurant serves delicious veal saltimbocca, chicken piccata, and redfish. They highlight the reasonable prices and generous portions. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-8d34-7498-8e97-55c89aef6acc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8d34-7498-8e97-55c89aef6acc",
        "storage_key": "property/6767906449165637/019d7913-8d34-7498-8e97-55c89aef6acc.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.amerigo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3134931430254947506&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amerigo-italian-restaurant",
      "poi_latitude": "32.402115",
      "poi_longitude": "-90.1075574",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-977-0563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40ba-7684-986a-7a4135bf2f90",
        "storage_key": "property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP94qGKrTKYYRsqyNt4aDgSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_00ad7146-bd64-471e-ba39-cdc802a6a5f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Phở Huong Vietnamese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6547 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Casual eatery specializing in Vietnamese staples like pho and bun.",
      "poi_long_description": "People say this Vietnamese restaurant serves amazing pho, fried egg rolls, and vermicelli noodles with grilled pork. They also highlight the authentic atmosphere, friendly service, and family vibe.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-9505-7580-838d-8ede8b516da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9505-7580-838d-8ede8b516da2",
        "storage_key": "property/6767906449165637/019d7913-9505-7580-838d-8ede8b516da2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nyage.net/ph-huong-vietnamese-restaurant",
      "poi_directions_map_url": "https://maps.google.com/?cid=12034883049803488317&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ph-huong-vietnamese-restaurant",
      "poi_latitude": "32.4013101",
      "poi_longitude": "-90.1088768",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 769-208-8086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40ba-7684-986a-7a4135bf2f90",
        "storage_key": "property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwxxnQDTKYYRPRzoyF5-BKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_ac329ebc-47c8-449b-91f7-609e4d6bf6f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Cock of the Walk",
      "poi_type": "Restaurants",
      "poi_address": "141 Madison Landing Cir, Ridgeland, MS 39157, USA",
      "poi_short_description": "Catfish, chicken & shrimp fried in peanut oil, plus steaks in a homey, wood-paneled restaurant.",
      "poi_long_description": "People say this seafood restaurant serves delicious fish fillets, coleslaw, and cornbread. They also highlight the friendly and attentive service, and the beautiful waterfront view.\n\nSome reviews mention the atmosphere can be dated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-94b6-71da-961c-a6401f8b8cd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-94b6-71da-961c-a6401f8b8cd6",
        "storage_key": "property/6767906449165637/019d7913-94b6-71da-961c-a6401f8b8cd6.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://cockofthewalk.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11995087875334198773&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cock-of-the-walk",
      "poi_latitude": "32.4227783",
      "poi_longitude": "-90.0844445",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-856-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-40ba-7684-986a-7a4135bf2f90",
        "storage_key": "property/6767906449165637/019cfb4b-40ba-7684-986a-7a4135bf2f90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQn_opLTKYYR9dXjst4cd6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_30025259-b930-47f2-85db-0b46b2fc7b97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "815 S Wheatley St, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain department store offering a selection of merchandise, including furniture, clothing, and electronics.",
      "poi_long_description": "People say this department store offers a large selection of quality products and reasonable prices.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-9acd-74b5-a6b1-15347772946d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9acd-74b5-a6b1-15347772946d",
        "storage_key": "property/6767906449165637/019d7913-9acd-74b5-a6b1-15347772946d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/875-ridgeland-ms/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17328793411972118502&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.4017143",
      "poi_longitude": "-90.1339645",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 601-956-2717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-4083-7495-b48c-87b311c7787c",
        "storage_key": "property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYUshPGDSKYYR5je62ss9fPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_94f9d0c0-8159-4b3c-8807-cc2531daaff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Van's Comics, Cards & Games",
      "poi_type": "Shopping & Retail",
      "poi_address": "731 S Pear Orchard Rd Suite 1, Ridgeland, MS 39157, USA",
      "poi_short_description": "Comic book store and gaming venue inside Odyssey North Shopping Center selling trading cards, board games, and video games.",
      "poi_long_description": "People say this comic book store offers a wide selection of comics, games, miniatures, and collectibles, including a great Wonder Woman selection. They highlight the fun and welcoming atmosphere, and the opportunity to enjoy hobbies with family and friends. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-a2ca-7239-941b-e340759fb9e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a2ca-7239-941b-e340759fb9e4",
        "storage_key": "property/6767906449165637/019d7913-a2ca-7239-941b-e340759fb9e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.facebook.com/vansccg",
      "poi_directions_map_url": "https://maps.google.com/?cid=399788903539180586&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "van-s-comics-cards-games",
      "poi_latitude": "32.4036826",
      "poi_longitude": "-90.1238081",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-898-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-4083-7495-b48c-87b311c7787c",
        "storage_key": "property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxQa3SjvSKYYRKoSYvONVjAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_7b3919e7-38bf-4dd6-9445-d08b05d6172d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Ridgewood Court Drive & Ridgewood Court Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Jackson, MS 39211, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4643659809954143520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgewood-court-drive-ridgewood-court-shopping-center",
      "poi_latitude": "32.3974801",
      "poi_longitude": "-90.137404",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-42fe-76ad-a23b-54fd06b08819",
        "storage_key": "property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj07aG4nSKYYRIB0Tdv6XcUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_3bb94c48-9918-4b68-bbc7-90204fe6e812",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "At Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "6360 Ridgewood Ct Dr, Jackson, MS 39211, USA",
      "poi_short_description": "Chain selling furniture, rugs, decorations and other home goods at low prices.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-a488-7229-b391-3099198b7d2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a488-7229-b391-3099198b7d2c",
        "storage_key": "property/6767906449165637/019d7913-a488-7229-b391-3099198b7d2c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.athome.com/store/mississippi-jackson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2567689648934383913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "at-home",
      "poi_latitude": "32.3949737",
      "poi_longitude": "-90.1379943",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 769-235-2877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-4083-7495-b48c-87b311c7787c",
        "storage_key": "property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ77gNKY_SKYYRKXEuqiFEoiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_4e675d1f-aaf8-48b6-9c9a-4a63aba8c553",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Guitar Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1189 E County Line Rd, Jackson, MS 39211, USA",
      "poi_short_description": "Retailer with a vast selection of guitars, amps, drums, and other musical instruments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-a72d-741f-8687-cfde079e68be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a72d-741f-8687-cfde079e68be",
        "storage_key": "property/6767906449165637/019d7913-a72d-741f-8687-cfde079e68be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.guitarcenter.com/ms/jackson/790?source=4SOSBM6BAM",
      "poi_directions_map_url": "https://maps.google.com/?cid=519430193456014744&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "guitar-center",
      "poi_latitude": "32.3982308",
      "poi_longitude": "-90.1325545",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-956-8053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-42fe-76ad-a23b-54fd06b08819",
        "storage_key": "property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6bMWAovSKYYRmOWORgJjNQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_9595ea22-a6f3-4ad9-b36d-09e9f5eb55f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Antique Mall of the South",
      "poi_type": "Shopping & Retail",
      "poi_address": "367 US-51, Ridgeland, MS 39157, USA",
      "poi_short_description": "Antique store offering a variety of items in a clean, well-organized space.",
      "poi_long_description": "People say this antique store offers a wide variety of unique finds, including collectible glassware and furniture. They also highlight the clean, well-organized displays and the helpful staff and booth owners.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-a67f-71da-bc19-bfd3015ab6d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a67f-71da-bc19-bfd3015ab6d8",
        "storage_key": "property/6767906449165637/019d7913-a67f-71da-bc19-bfd3015ab6d8.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "http://www.antiquemallofthesouth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6961493070068046285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "antique-mall-of-the-south",
      "poi_latitude": "32.4191002",
      "poi_longitude": "-90.1359806",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-853-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-4083-7495-b48c-87b311c7787c",
        "storage_key": "property/6767906449165637/019cfb4b-4083-7495-b48c-87b311c7787c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuZOOB2zSKYYRzdm_SxAxnGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_793c6f62-4e65-4b17-a669-c8ecf2dee1b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "B&B Theatres Ridgeland Northpark 14",
      "poi_type": "Entertainment",
      "poi_address": "250 Ring Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "People say this movie theater offers comfortable seating and a luxurious, up-to-date atmosphere.\n\nOther reviews mention the movie experience can be disrupted by technical issues and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-acfc-777e-8228-e682335f432b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-acfc-777e-8228-e682335f432b",
        "storage_key": "property/6767906449165637/019d7913-acfc-777e-8228-e682335f432b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x02x0-b-and-b-theatres-ridgeland-northpark-14/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16856495913629596744&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "b-b-theatres-ridgeland-northpark-14",
      "poi_latitude": "32.40563789999999",
      "poi_longitude": "-90.1294076",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-202-9890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-c1fc-75f4-8406-1dddc4bf4102.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-c1fc-75f4-8406-1dddc4bf4102",
        "storage_key": "property/6767906449165637/019d7913-c1fc-75f4-8406-1dddc4bf4102.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9RvCY3TKYYRSDy3UblN7uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f3d6eeab-3aed-4ad8-a771-c81251f32e54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Friendship Park",
      "poi_type": "Entertainment",
      "poi_address": "475 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed park with a playground, swings, slides and fitness equipment plus picnic tables and walking trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-af27-75ce-ab60-b0cc121f9dd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-af27-75ce-ab60-b0cc121f9dd6",
        "storage_key": "property/6767906449165637/019d7913-af27-75ce-ab60-b0cc121f9dd6.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.ridgelandms.org/city-departments/recreation-and-parks/facilities/#Friendship-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12704319735673983707&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "32.412771",
      "poi_longitude": "-90.1208439",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-430c-76cd-acf7-e04825165ae9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-430c-76cd-acf7-e04825165ae9",
        "storage_key": "property/6767906449165637/019cfb4b-430c-76cd-acf7-e04825165ae9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Rc3SLXTKYYR2xLVPX3PTrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d87e1dd7-6370-4127-bd07-7200a7a0281f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Enter/Locked Escape Rooms",
      "poi_type": "Entertainment",
      "poi_address": "6718 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Escape-game center offering five themed rooms for private group challenges.",
      "poi_long_description": "People say this amusement center offers fun and challenging escape rooms with clever puzzles. They highlight the immersive experience, unique themes, and interactive rooms. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-aeac-73a1-b65f-5c67c68327a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-aeac-73a1-b65f-5c67c68327a3",
        "storage_key": "property/6767906449165637/019d7913-aeac-73a1-b65f-5c67c68327a3.webp",
        "width": 1241,
        "height": 650
      },
      "poi_business_url": "https://www.enterlocked.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8297131859657073285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "enter-locked-escape-rooms",
      "poi_latitude": "32.408895",
      "poi_longitude": "-90.1058825",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-665-3299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-42fe-76ad-a23b-54fd06b08819",
        "storage_key": "property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZY297q7TKYYRhaJvXXdVJXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_7e83a73d-ae2f-472a-a315-caacbd5ff3c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Ridgeland Wildflower Field",
      "poi_type": "Entertainment",
      "poi_address": "411 W Jackson St, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-b436-77bf-ba0a-f545f565bf2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b436-77bf-ba0a-f545f565bf2c",
        "storage_key": "property/6767906449165637/019d7913-b436-77bf-ba0a-f545f565bf2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridgelandms.org/city-departments/recreation-and-parks/facilities-and-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13921465850862569259&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgeland-wildflower-field",
      "poi_latitude": "32.4298388",
      "poi_longitude": "-90.1420541",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-430c-76cd-acf7-e04825165ae9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-430c-76cd-acf7-e04825165ae9",
        "storage_key": "property/6767906449165637/019cfb4b-430c-76cd-acf7-e04825165ae9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3eO6KIXTKYYRKwdlqW77MsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_22ba7d4c-a161-405c-903e-24bcf121f22b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Reservoir Overlook",
      "poi_type": "Entertainment",
      "poi_address": "Natchez Trace Pkwy, Madison, MS 39110, USA",
      "poi_short_description": "Scenic paved path and road with overlooks and picnic tables, plus a reservoir.",
      "poi_long_description": "People say this scenic spot offers beautiful views of the reservoir, perfect for photography, fishing, and picnics. They highlight the peaceful and relaxing vibe, ideal for a break or a quiet afternoon. They also like the nearby walking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019d7913-baac-71bd-b2e3-0a7189e2036d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-baac-71bd-b2e3-0a7189e2036d",
        "storage_key": "property/6767906449165637/019d7913-baac-71bd-b2e3-0a7189e2036d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nps.gov/places/reservoir-overlook.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=5005086383217288503&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "reservoir-overlook",
      "poi_latitude": "32.4372776",
      "poi_longitude": "-90.0738646",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-305-7417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-42fe-76ad-a23b-54fd06b08819",
        "storage_key": "property/6767906449165637/019cfb4b-42fe-76ad-a23b-54fd06b08819.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPViphgfUKYYRN6XPJYyjdUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "scenic_spot"
    },
    {
      "id": "custom_b315a19b-3ed9-44a2-8b25-6ce7887d8e37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Olde Towne Middle School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "olde-towne-middle-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b00ed76-843c-4761-b4b8-ad83db13d1fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "poi_name": "Sambou’s African Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "sambou-s-african-kitchen",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9c9e17220ae6b320cbd21085",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_95b9cfff211c50464af95ae2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ec1e1fe94d263d5d2f0106a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5979033442f32a90abb6ab75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9fef0ea2cf3b4cae158a392c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_e077ce30db6820680b1b873d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6952a827b52a4b0f0db633b7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "rating": "5",
      "name": "Vivek Malviya",
      "text": "I’ve been living in this apartment community and couldn’t be happier. The property manager, leasing staff, and maintenance team are all top-notch — professional, friendly, and always responsive. Maintenance requests are handled promptly and effectively, which makes life here worry-free.\n\nThe neighborhood is quiet and peaceful, perfect for relaxation or work-from-home days. Everything you need on a daily basis is conveniently nearby — Walmart, Kroger, Lowe’s, a variety of eateries, and a mall are all within a 5-minute drive. Costco and Target are just a short drive away, and the interstate is easily accessible for commuting or weekend trips.\n\nOverall, this community offers a fantastic combination of great service, convenient location, and a comfortable living environment. Highly recommended!",
      "date": "2025-08-22",
      "title": "false"
    },
    {
      "id": "ec_55c67ce979d30c93f398e200",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "rating": "5",
      "name": "Sumit Sontakke",
      "text": "We lived here for around 7 years, and it has truly been a wonderful experience. The office staff is incredibly friendly, professional, and always willing to help with anything you need. They made us feel welcome from day one and were always just a call or visit away. Maintenance is impressively quick and efficient, every time we submitted a request, it was taken care of promptly. The maintenance team is awesome and friendly. The community is very safe and well-maintained, and we always felt comfortable living here. We really enjoyed our time, this place felt like home. We’re so grateful for the experience! We would absolutely recommend this complex to anyone looking for a safe, friendly, and well-managed place to live. Thank you for everything!!",
      "date": "2025-04-02",
      "title": "false"
    },
    {
      "id": "ec_6babc8b747421d170cf2b33c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "rating": "5",
      "name": "Erin Halvorson",
      "text": "Wonderful management and maintenance staff! Always go above and beyond the call of duty for their residents. Property is well maintained, upkeep is regularly performed and any issues are addresses promptly.",
      "date": "2025-08-19",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e6850882-3688-4fd3-b4d8-734139121102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-a6ce-762e-b1ad-e23f2877b9c4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of the outdoor swimming pool and lounge area with trees in the background.",
        "public_id": "019cfb4b-a6ce-762e-b1ad-e23f2877b9c4",
        "storage_key": "property/6767906449165637/019cfb4b-a6ce-762e-b1ad-e23f2877b9c4.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Trace of Ridgeland Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5fa43ac3f9757f3e73bd2c25"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-7012-7081-b552-2e71aadc51d5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "trace-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637"
    },
    {
      "lead_collector_id": "019cf79e-708b-719d-8580-651d55b5946c",
      "lead_source": "LANDING_PAGE",
      "name": "trace-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "generator",
      "page_item_url": "apartments-with-pool-ridgeland-ms",
      "search_query": "apartments with pool in Ridgeland MS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Ridgeland, MS",
      "h2_subtitle": "Discover the perfect retreat with Trace Apts., offering apartments with a fantastic pool in Ridgeland, MS. Dive into comfort and style today!",
      "page_copy": "Escape to Trace Apts. in Ridgeland, MS, where our community features luxurious apartments with pool access. Ideal for relaxation and recreation, our sparkling pools provide a refreshing escape right at your doorstep. Whether you're looking to swim laps or simply lounge with a good book, our pool area is designed to cater to all your leisure needs.\n\nIn addition to vibrant poolside experiences, residents at Trace Apts. enjoy a host of other amenities. From our modern fitness center and tennis courts to serene picnic areas and well-maintained courtyards, there's plenty to explore and enjoy. With spacious one and two-bedroom options, make Trace Apts. your new home and embrace a lifestyle of relaxation and convenience in Ridgeland, Mississippi.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and dresser.",
        "public_id": "019cfb4b-0230-74db-8626-89586ac99d6b",
        "storage_key": "property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Ridgeland, MS",
      "seo_description": "Explore Trace Apts. with pools in Ridgeland, MS. Enjoy luxury living with great amenities. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-jackson-metro",
      "search_query": "air conditioned apartments in Jackson Metro",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Jackson Metro",
      "h2_subtitle": "Stay cool and comfortable at Trace Apts., offering air conditioned apartments in the Jackson Metro area. Experience ultimate comfort year-round!",
      "page_copy": "Experience unparalleled comfort at Trace Apts., featuring air conditioned apartments in the Jackson Metro area. Nestled in Ridgeland, our community offers a perfect blend of modern comforts and convenient amenities, ensuring a pleasant living experience. Stay cool through Mississippi's warm summers with our efficient air conditioning systems installed in every apartment.\n\nBeyond climate control, Trace Apts. boasts numerous amenities that elevate your lifestyle. Residents can enjoy access to high-speed internet, spacious floor plans, and lush courtyards designed for relaxation. Whether you're working remotely or unwinding after a long day, our air conditioned apartments provide the perfect haven in the heart of the Jackson Metro area, ensuring that comfort is always within reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and dresser.",
        "public_id": "019cfb4b-0230-74db-8626-89586ac99d6b",
        "storage_key": "property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Jackson Metro",
      "seo_description": "Find comfortable air conditioned apartments near Jackson Metro at Trace Apts. Enjoy modern amenities and a great location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-northpark",
      "search_query": "dishwasher-equipped apartments near Northpark",
      "category": "Amenity",
      "h1_title": "Dishwasher-Equipped Apartments Near Northpark",
      "h2_subtitle": "Explore Trace Apts., offering dishwasher-equipped apartments near Northpark. Enjoy modern conveniences right at your doorstep!",
      "page_copy": "At Trace Apts., located conveniently near Northpark, we offer dishwasher-equipped apartments designed to simplify your daily life. Say goodbye to manual dishwashing and savor the ease of modern living with a built-in dishwasher in every unit. Our community offers not only convenience but a vibrant lifestyle in the heart of Ridgeland.\n\nIn addition to benefiting from a full suite of in-home amenities, Trace Apts. residents enjoy access to excellent shared facilities such as refreshing pools, a fully-equipped fitness center, and serene picnic areas. Nestled close to Northpark, our community provides easy access to shopping and entertainment, making everyday errands a breeze. Discover the blend of comfort and practicality at Trace Apts. today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and dresser.",
        "public_id": "019cfb4b-0230-74db-8626-89586ac99d6b",
        "storage_key": "property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher-Equipped Apartments Near Northpark",
      "seo_description": "Enjoy dishwasher-equipped apartments near Northpark at Trace Apts. Offering modern amenities and convenience in Ridgeland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "generator",
      "page_item_url": "high-speed-internet-apartments-madison-county",
      "search_query": "high-speed internet apartments in Madison County",
      "category": "Amenity",
      "h1_title": "High-Speed Internet Apartments in Madison County",
      "h2_subtitle": "Stay connected with Trace Apts., offering high-speed internet apartments within Madison County. Perfect for work and play!",
      "page_copy": "Trace Apts. in Ridgeland offers high-speed internet apartments designed for the tech-savvy resident. Located in Madison County, our community ensures seamless connectivity for work, studies, and entertainment. Whether you're streaming your favorite shows or managing remote work, our high-speed internet provides the reliability you need.\n\nLocated in a prime area, Trace Apts. combines technological advantages with luxurious amenities. Relax by our refreshing pools, enjoy the well-equipped fitness center, or take advantage of our tranquil picnic spaces. With a choice of spacious floor plans, Trace Apts. is the ideal place for those seeking both modern conveniences and a welcoming community atmosphere within Madison County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and dresser.",
        "public_id": "019cfb4b-0230-74db-8626-89586ac99d6b",
        "storage_key": "property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-Speed Internet Apartments in Madison County",
      "seo_description": "Discover high-speed internet apartments in Madison County at Trace Apts. Enjoy seamless connectivity and excellent amenities in Ridgeland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "generator",
      "page_item_url": "luxury-apartments-walk-in-closets-39157",
      "search_query": "luxury apartments with walk-in closets in 39157",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Walk-In Closets in 39157",
      "h2_subtitle": "Discover Trace Apts. in 39157, featuring luxury apartments with spacious walk-in closets. Enjoy ample storage in style!",
      "page_copy": "Step into luxury at Trace Apts. in the 39157 area, where our apartments boast expansive walk-in closets designed for your convenience. Our community offers a blend of elegance and practicality, providing residents with ample storage solutions that make organizing effortless.\n\nIn addition to generous closet space, residents enjoy access to a wealth of amenities. Dive into our refreshing pools, stay fit at our state-of-the-art fitness center, or enjoy quiet moments in our lush courtyards. Trace Apts. combines modern comforts with sophisticated living, making it the ideal destination for those who desire luxury and convenience right in the heart of Ridgeland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and dresser.",
        "public_id": "019cfb4b-0230-74db-8626-89586ac99d6b",
        "storage_key": "property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments With Walk-In Closets in 39157",
      "seo_description": "Explore luxury apartments in 39157 at Trace Apts., featuring walk-in closets and upscale amenities. Find your perfect home in Ridgeland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-ridgeland-ms",
      "search_query": "one bedroom apartments ridgeland ms",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Ridgeland, MS",
      "h2_subtitle": "Welcome to Trace Apts., featuring spacious one bedroom apartments in Ridgeland, MS. Perfect for singles or couples!",
      "page_copy": "Discover the ideal one bedroom apartments at Trace Apts. in Ridgeland, MS. Our community offers thoughtfully designed units that provide both comfort and style, perfect for singles or couples seeking a cozy living space. With modern amenities and ample living areas, you'll find everything you need right at home.\n\nBeyond the walls of your apartment, enjoy a suite of community amenities including refreshing pools, a fitness center, and serene picnic areas. Located in vibrant Ridgeland, MS, Trace Apts. not only provides a desirable living environment but also easy access to nearby shopping, dining, and entertainment. Experience convenience and practicality at Trace Apts. today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and dresser.",
        "public_id": "019cfb4b-0230-74db-8626-89586ac99d6b",
        "storage_key": "property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Ridgeland, MS",
      "seo_description": "Find spacious one bedroom apartments in Ridgeland, MS at Trace Apts. Ideal for singles or couples seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165637",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-39157",
      "search_query": "two bedroom apartments near 39157",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 39157",
      "h2_subtitle": "Explore Trace Apts. for spacious two bedroom apartments near 39157. Perfect for families or roommates!",
      "page_copy": "Looking for spacious living near 39157? Trace Apts. offers beautiful two bedroom apartments designed for both comfort and function. Whether you're setting up with a roommate or need more room for a family, our apartments provide ample space and modern amenities that make living easy.\n\nTrace Apts. doesn't stop at just beautiful interiors; our community is rich with features that enhance your life. Relax beside our refreshing pools, keep active at the fitness center, or spend quality time at our serene picnic areas. Situated in the thriving community of Ridgeland, our location offers convenient access to local dining and entertainment options, perfect for all lifestyles.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
      "featured_image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and dresser.",
        "public_id": "019cfb4b-0230-74db-8626-89586ac99d6b",
        "storage_key": "property/6767906449165637/019cfb4b-0230-74db-8626-89586ac99d6b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 39157",
      "seo_description": "Discover spacious two bedroom apartments near 39157 at Trace Apts. Ideal for families or roommates seeking comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5221"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-K20NK5ZNQW"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151156"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-trace-of-ridgeland/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KCLKGJNP"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165637/019d1bda-9675-745e-ae0c-0dc9741282a1.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "16038094159"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "fe232624-7030-4e6d-8c99-5e04a03125a7"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-686-0682"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af79c6fb804c00aee1fd"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkFNbmJwbWxacm54RFppSVFNQnU2SkE9PSIsInZhbHVlIjoiaUJua0E3ZFN2cWhvczdQNnpUVGd2Zz09IiwibWFjIjoiOTQxOGQzNmUxODhjMWJjYjUyMzkxYTkwMDU2NzZjM2M3NzdiNzE0YWRmYzFmNmUxZjYyZTRiMDI2NzczYmYwYiJ9"
    }
  ],
  "custom_qb_id": "5221",
  "custom_ga4_id": "G-K20NK5ZNQW",
  "custom_repli_id": "10041151156",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-trace-of-ridgeland/register/",
  "custom_google_gtm_id": "GTM-KCLKGJNP",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165637/019d1bda-9675-745e-ae0c-0dc9741282a1.pdf",
  "custom_hubspot_company_id": "16038094159",
  "custom_rentgrata_property_id": "fe232624-7030-4e6d-8c99-5e04a03125a7",
  "custom_ppc_tracking_phone_number": "833-686-0682",
  "custom_residentboost_apartment_id": "6504af79c6fb804c00aee1fd",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkFNbmJwbWxacm54RFppSVFNQnU2SkE9PSIsInZhbHVlIjoiaUJua0E3ZFN2cWhvczdQNnpUVGd2Zz09IiwibWFjIjoiOTQxOGQzNmUxODhjMWJjYjUyMzkxYTkwMDU2NzZjM2M3NzdiNzE0YWRmYzFmNmUxZjYyZTRiMDI2NzczYmYwYiJ9"
};

export const generatedAt = '2026-08-27T21:35:39.397Z';
